import type React from 'react';

import { TabList, Tabs } from '@change/ds-core-ui/Tabs';

import { useI18n } from '@change-corgi/core-react/i18n';

export const PageTabs: React.FC<EmptyProps> = () => {
	const { translate } = useI18n();
	return (
		<div className="container mb-4 px-0">
			<Tabs selectedKey="">
				<TabList
					items={[
						{
							id: 'about',
							label: translate('fe.components.brand_pages_navbar.about'),
							href: '/about',
						},
						{
							id: 'careers',
							label: translate('fe.components.brand_pages_navbar.careers'),
							href: '/careers',
						},
						{
							id: 'team',
							label: translate('fe.components.brand_pages_navbar.team'),
							href: '/about/team',
						},
					]}
				/>
			</Tabs>
		</div>
	);
};
